(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5202],{

/***/ 94501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CourseInfo_KlassInfoHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 230 modules
var esm = __webpack_require__(67804);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./shared/hooks/useCopyUrlShare.tsx
var useCopyUrlShare = __webpack_require__(99118);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-click-outside/use-click-outside.js
var use_click_outside = __webpack_require__(10753);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Sharebox/index.tsx




var Sharebox = function(param) {
    var shareList = param.shareList, onClose = param.onClose;
    var shareboxOutsideRef = (0,use_click_outside/* useClickOutside */.O)(function() {
        return onClose();
    }, null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: shareboxOutsideRef,
        className: "absolute right-0 top-9 z-30 rounded-lg border bg-white p-6",
        style: {
            boxShadow: " 0px 0px 20px 0px rgba(0, 0, 0, 0.1)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
            children: shareList.map(function(param, idx) {
                var imgSrc = param.imgSrc, title = param.title, onShareHandler = param.onShareHandler, id = param.id;
                var isFirst = lodash_default().isEqual(idx, 0);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: id,
                    className: "flex cursor-pointer ".concat(isFirst ? "" : "mt-4"),
                    onClick: onShareHandler,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                            className: "relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: imgSrc,
                                width: 40,
                                height: 40,
                                alt: "".concat(title, " 아이콘")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                            className: "ml-4 flex items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-normal",
                                children: title
                            })
                        })
                    ]
                }, title);
            })
        })
    });
};
/* harmony default export */ var components_Sharebox = (Sharebox);

// EXTERNAL MODULE: ./components/Modal/index.tsx
var Modal = __webpack_require__(66305);
// EXTERNAL MODULE: ./components/Sharebox/ShareboxDialog.module.scss
var ShareboxDialog_module = __webpack_require__(98384);
var ShareboxDialog_module_default = /*#__PURE__*/__webpack_require__.n(ShareboxDialog_module);
;// CONCATENATED MODULE: ./components/Sharebox/ShareboxDialog.tsx





var ShareboxDialog = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, shareList = param.shareList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        isOpen: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "rounded-lg bg-white px-4 py-6 ".concat((ShareboxDialog_module_default()).ShareboxDialogWrapper),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-center text-xl font-bold",
                            children: "공유하기"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "flex h-5 w-5 items-center justify-center",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* XIcon */.b0D, {
                                className: "h-auto w-5"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "mb-2 mt-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                        className: "flex w-full gap-5",
                        children: shareList.map(function(param) {
                            var imgSrc = param.imgSrc, title = param.title, onShareHandler = param.onShareHandler, id = param.id;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: id,
                                className: "flex cursor-pointer flex-col",
                                onClick: onShareHandler,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                        className: "relative flex items-center justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: imgSrc,
                                            width: 50,
                                            height: 50,
                                            alt: "".concat(title, " 아이콘")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                        className: "mt-2 flex items-center justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-normal",
                                            children: title
                                        })
                                    })
                                ]
                            }, title);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Sharebox_ShareboxDialog = (ShareboxDialog);

;// CONCATENATED MODULE: ./components/CourseInfo/KlassInfoHeader.tsx







var KlassInfoHeader = function(param) {
    var isMobile = param.isMobile, klassId = param.klassId, title = param.title, panelText = param.panelText, shareUrl = param.shareUrl, imgUrl = param.imgUrl;
    var ref = (0,useCopyUrlShare/* useCopyUrlShare */.r)(), copyUrlShare = ref.copyUrlShare, isDialogOpened = ref.isDialogOpened, onDialogOpenHandler = ref.onDialogOpenHandler, onDialogCloseHandler = ref.onDialogCloseHandler;
    var defaultUrl = (0,react.useMemo)(function() {
        return (klassId === null || klassId === void 0 ? void 0 : klassId.includes("kdc")) ? "https://likelion.net/onboarding/".concat(klassId) : "https://likelion.net/school/".concat(klassId);
    }, [
        klassId
    ]);
    var shareList = [
        {
            id: "kakao",
            imgSrc: "/svg/icon_share_kakao.svg",
            title: "카카오톡",
            installTalk: true,
            onShareHandler: (0,react.useCallback)(function() {
                if (shareUrl && !lodash_default().isUndefined(shareUrl.kakao)) {
                    window.Kakao.Share.sendDefault({
                        objectType: "feed",
                        content: {
                            title: title,
                            description: panelText,
                            imageUrl: imgUrl,
                            link: {
                                mobileWebUrl: shareUrl ? shareUrl.kakao : defaultUrl,
                                webUrl: shareUrl ? shareUrl.kakao : defaultUrl
                            }
                        },
                        buttons: [
                            {
                                title: "멋사에서 보기",
                                link: {
                                    mobileWebUrl: shareUrl ? shareUrl.kakao : defaultUrl,
                                    webUrl: shareUrl ? shareUrl.kakao : defaultUrl
                                }
                            }, 
                        ]
                    });
                }
            }, [
                imgUrl,
                panelText,
                shareUrl,
                title
            ])
        },
        {
            id: "url",
            imgSrc: "/svg/icon_share_url.svg",
            title: "URL복사",
            onShareHandler: (0,react.useCallback)(function() {
                return copyUrlShare(shareUrl ? shareUrl.url : defaultUrl);
            }, [
                copyUrlShare,
                defaultUrl,
                shareUrl, 
            ])
        }, 
    ];
    var shareListFilter = (0,react.useMemo)(function() {
        return (klassId === null || klassId === void 0 ? void 0 : klassId.includes("kdc")) || (klassId === null || klassId === void 0 ? void 0 : klassId.includes("kdt")) ? shareList : shareList.filter(function(item) {
            return item.id !== "kakao";
        });
    }, [
        klassId
    ]);
    (0,react.useEffect)(function() {
        if ( true && !window.Kakao.isInitialized()) {
            window.Kakao.init("".concat(window.kakaoShare));
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "flex items-start justify-between ".concat(isMobile ? "" : "relative", " ").concat(panelText ? "" : "mb-[18px] border-b"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "break-keep text-xl font-semibold ".concat(panelText ? "" : "mb-3"),
                        style: {
                            lineHeight: isMobile ? 1.3 : 1.375
                        },
                        children: title
                    }),
                    !lodash_default().isEmpty(shareUrl) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ShareIcon */.aAc, {
                                className: "ml-2.5 h-auto w-6 shrink-0 cursor-pointer",
                                onClick: function() {
                                    onDialogOpenHandler();
                                }
                            }),
                            !isMobile && isDialogOpened && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Sharebox, {
                                shareList: shareListFilter,
                                onClose: onDialogCloseHandler
                            })
                        ]
                    })
                ]
            }),
            panelText && !klassId.includes("kdc") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-[18px] break-keep border-b py-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-sm text-gray-500",
                    children: panelText
                })
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sharebox_ShareboxDialog, {
                isOpen: isDialogOpened,
                onClose: onDialogCloseHandler,
                shareList: shareListFilter
            })
        ]
    });
};
/* harmony default export */ var CourseInfo_KlassInfoHeader = (KlassInfoHeader);


/***/ }),

/***/ 97205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var HTMLRender = function(param) {
    var html = param.html;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HTMLRender);


/***/ }),

/***/ 66305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49196);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18346);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83317);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34065);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76058);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_8__);







var Modal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, children = param.children, transition = param.transition;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useScrollLock */ .P)(), 2), lockScroll = ref[0], setLockScroll = ref[1];
    var isTablet = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useMediaQuery */ .a)("(max-width: 1023px)");
    var isMobile = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useMediaQuery */ .a)("(max-width: 767px)");
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useLayoutEffect)(function() {
        var mobileResizeWindow = function() {
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
        };
        mobileResizeWindow();
        window.addEventListener("resize", mobileResizeWindow);
        if (router.pathname.includes("enterprise")) {
            setLockScroll(false);
        } else if (isOpen && isTablet) {
            setLockScroll(true);
        } else {
            setLockScroll(false);
        }
        return function() {
            window.removeEventListener("resize", mobileResizeWindow);
        };
    }, [
        isOpen
    ]);
    var onKeyBoardModalHandler = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(e) {
        if (e.key === "Escape") {
            onClose();
        }
    }, [
        onClose
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        document.addEventListener("keydown", onKeyBoardModalHandler);
        return function() {
            document.removeEventListener("keydown", onKeyBoardModalHandler);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .u, {
        show: isOpen,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
        enterTo: "opacity-100 translate-y-0 sm:scale-100",
        children: !transition ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Dialog */ .V, {
            open: isOpen,
            onClose: onClose,
            initialFocus: containerRef,
            className: "fixed inset-0 z-200 ".concat((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ModalContainer)),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex h-full items-center justify-center",
                onMouseDown: function(e) {
                    return e.stopPropagation();
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Dialog.Overlay */ .V.Overlay, {
                        className: "absolute left-0 top-0 z-40 h-screen w-screen overflow-hidden ".concat((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().BgOpacity55), " ").concat((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heightfill))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: containerRef,
                        className: "z-50 overflow-y-auto ".concat((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ModalWrapper)),
                        children: children
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition.Child */ .u.Child, {
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Dialog */ .V, {
                open: isOpen,
                onClose: onClose,
                initialFocus: containerRef,
                className: "fixed inset-0 z-200 ".concat((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ModalContainer)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex h-full items-center justify-center",
                    onMouseDown: function(e) {
                        return e.stopPropagation();
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Dialog.Overlay */ .V.Overlay, {
                            className: "absolute left-0 top-0 z-40 h-screen w-screen overflow-hidden ".concat((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().BgOpacity55), " ").concat((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heightfill))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            ref: containerRef,
                            className: "z-50 overflow-y-auto ".concat((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ModalWrapper)),
                            children: children
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 99118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useCopyUrlShare; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34065);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72132);
/* harmony import */ var _useDialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39703);






var useCopyUrlShare = function() {
    var ref = (0,_useDialog__WEBPACK_IMPORTED_MODULE_2__/* .useDialog */ .R)(), isDialogOpened = ref.isDialogOpened, onDialogOpenHandler = ref.onDialogOpenHandler, onDialogCloseHandler = ref.onDialogCloseHandler;
    var isMobile = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useMediaQuery */ .a)("(max-width: 767px)");
    var copyUrlShare = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(url) {
            var position, hiddenText, e;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        position = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "top-center";
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            6,
                            7
                        ]);
                        if (!("clipboard" in navigator)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            navigator.clipboard.writeText(url)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        hiddenText = document.createElement("textarea");
                        hiddenText.innerText = url;
                        document.body.appendChild(hiddenText);
                        hiddenText.select();
                        document.execCommand("copy");
                        hiddenText.remove();
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-bold text-white lg:text-xl",
                                children: "링크가 복사되었습니다."
                            }), {
                                toastId: "urlCopy",
                                position: position,
                                className: position === "bottom-center" ? "bottom-30 px-4 py-3 lg:px-6 lg:py-5 rounded-md mx-auto tracking-tight" : "top-6 lg:top-28 px-4 py-3 lg:px-6 lg:py-5 rounded-md mx-auto tracking-tight",
                                bodyClassName: "p-0 flex items-center",
                                closeButton: false,
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/svg/icon_solid_check.svg",
                                    width: 22,
                                    height: 22,
                                    alt: "check icon"
                                }),
                                style: {
                                    backgroundColor: "#393939",
                                    width: isMobile ? "227px" : "290px"
                                },
                                transition: react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .Zoom */ .LG
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        console.error(e);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        onDialogCloseHandler();
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function copyUrlShare(url) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        copyUrlShare: copyUrlShare,
        isDialogOpened: isDialogOpened,
        onDialogOpenHandler: onDialogOpenHandler,
        onDialogCloseHandler: onDialogCloseHandler
    };
};


/***/ }),

/***/ 7316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gn": function() { return /* binding */ convertToEcommerceItem; },
/* harmony export */   "RD": function() { return /* binding */ convertToPurchaseData; }
/* harmony export */ });
/* unused harmony exports convertToImpressionData, convertToProductData */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

var convertToImpressionData = function(item) {
    if (isArray(item)) return item.map(function(i) {
        return {
            id: i.id,
            name: i.title
        };
    });
    else return {
        id: item.id,
        name: item.title
    };
};
var convertToProductData = function(item) {
    return {
        id: item.id,
        name: item.title,
        price: item.price
    };
};
var convertToPurchaseData = function(item) {
    return {
        id: item.id,
        name: item.title,
        price: item.price,
        quantity: 1
    };
};
var convertToEcommerceItem = function(item) {
    if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.isArray)(item)) return item.map(function(i) {
        return {
            item_id: i.id,
            item_name: i.title,
            price: i.price,
            quantity: 1
        };
    });
    else return {
        item_id: item.id,
        item_name: item.title,
        price: item.price,
        quantity: 1
    };
};


/***/ }),

/***/ 76002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getCourseTotalTime; },
/* harmony export */   "b": function() { return /* binding */ sec2time; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1646);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_1__);



dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_1___default()));
// format 참고 - https://day.js.org/docs/en/durations/format
var sec2time = function(seconds, format) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default().duration(seconds * 1000).format(format);
};
var getCourseTotalTime = function(totalSeconds) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(sec2time(totalSeconds, "M:D:H:m").split(":"), 4), M = ref[0], D = ref[1], h = ref[2], m = ref[3];
    var hour = 0;
    if (Number(M) > 0) {
        hour = hour + Number(M) * 30 * 24;
    }
    if (Number(D) > 0) {
        hour = Number(D) * 24 + hour;
    }
    hour = hour + Number(h);
    return Number(m) === 0 ? "".concat(hour, "시간") : "".concat(hour, "시간 ").concat(m, "분");
};


/***/ }),

/***/ 76058:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"Modal_ModalContainer__GP2xU","heightfill":"Modal_heightfill__rjkhb","ModalWrapper":"Modal_ModalWrapper__vCCww","BgOpacity55":"Modal_BgOpacity55__QDIb_"};

/***/ }),

/***/ 98384:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ShareboxDialogWrapper":"ShareboxDialog_ShareboxDialogWrapper__yCpVo"};

/***/ })

}]);